var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11V12H17V11H16ZM8 11H7V12H8V11ZM13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15H13ZM11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17H11ZM6 12H18V10H6V12ZM19 13V19H21V13H19ZM18 20H6V22H18V20ZM5 19V13H3V19H5ZM6 20C5.44772 20 5 19.5523 5 19H3C3 20.6569 4.34315 22 6 22V20ZM19 19C19 19.5523 18.5523 20 18 20V22C19.6569 22 21 20.6569 21 19H19ZM18 12C18.5523 12 19 12.4477 19 13H21C21 11.3431 19.6569 10 18 10V12ZM6 10C4.34315 10 3 11.3431 3 13H5C5 12.4477 5.44772 12 6 12V10ZM15 7V11H17V7H15ZM16 10H8V12H16V10ZM9 11V7H7V11H9ZM12 4C13.6569 4 15 5.34315 15 7H17C17 4.23858 14.7614 2 12 2V4ZM12 2C9.23858 2 7 4.23858 7 7H9C9 5.34315 10.3431 4 12 4V2ZM11 15V17H13V15H11Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0abf1970a92830c5bf3e0ab57cfb22ca.svg";
export { ForwardRef as ReactComponent };